import axios from '@/core/axios';

import {
  OrderDiscount,
  OrderDiscountCreateResponse,
  OrderDiscountDeleteResponse,
  OrderDiscountPayload,
  OrderDiscountUpdateResponse
} from './order-discounts.types';

export class OrderDiscountsService {
  list(orderId: number): Promise<OrderDiscount[]> {
    return axios.get<OrderDiscount[]>(`/orders/${orderId}/discounts`).then(resp => resp?.data || []);
  }

  create(orderId: number, payload: OrderDiscountPayload): Promise<OrderDiscountCreateResponse> {
    return axios
      .post<OrderDiscountCreateResponse>(`/orders/${orderId}/discounts`, { order_discount: payload })
      .then(resp => resp?.data);
  }

  update(discountId: number, payload: OrderDiscountPayload): Promise<OrderDiscountUpdateResponse> {
    return axios
      .put<OrderDiscountUpdateResponse>(`/discounts/${discountId}`, { order_discount: payload })
      .then(resp => resp?.data);
  }

  delete(discountId: number): Promise<OrderDiscountDeleteResponse> {
    return axios.delete<OrderDiscountDeleteResponse>(`/discounts/${discountId}`).then(resp => resp?.data);
  }
}

export const orderDiscountsService = new OrderDiscountsService();
